import email from '../assets/email.webp';
import mobile from '../assets/mobile.webp';
import node from '../assets/node.webp';
import react from '../assets/react.webp';
import sass from '../assets/sass.webp';
import profile from '../assets/profile-683.webp';
import profileSmall from '../assets/profile-480.webp';
import circle from '../assets/circle.svg';
import logo from '../assets/logo-360.webp';
import logoSmall from '../assets/logo-180.webp';

const images = {
  email,
  mobile,
  node,
  react,
  sass,
  profile,
  profileSmall,
  circle,
  logo,
  logoSmall,
};

export default images;
